import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { GdsUsageReportComponent } from './gds-usage-report/gds-usage-report.component';
import { RateAuditSummaryReportComponent } from './rate-audit-summary-report/rate-audit-summary-report.component';
import { GdsUsageReportModule } from './gds-usage-report/gds-usage-report.module';
import { FailedEmailNotificationsComponent } from './failed-email-notifications/failed-email-notifications.component';
import { FailedEmailNotificationsModule } from './failed-email-notifications/failed-email-notifications.module';

import { RateAuditSummaryReportModule } from './rate-audit-summary-report/rate-audit-summary-report.module';

export const routableModules = [
  GdsUsageReportModule,
  RateAuditSummaryReportModule,
  FailedEmailNotificationsModule
];

export const routes: Routes = [
  {path:"gds-usage-report" , component: GdsUsageReportComponent},
  {path: "rate-audit-summary-report", component: RateAuditSummaryReportComponent},
  {path: "failed-email-notifications", component: FailedEmailNotificationsComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)
  ,routableModules],
  exports: [RouterModule]
})
export class ReportsRoutingModule { }
